/**
 * 작성자명 : 전찬민
 * 작성일자 : 2025.08.07 (목)
 * 작성내용 : 메뉴 이름을 추출하는 함수
 * @param values 메뉴 이름이 포함된 문자열 배열
 * @returns 메뉴 이름이 추출된 문자열 배열
 * @description 각 문자열에서 괄호 안의 내용을 추출하여 반환한다. 괄호가 없을 경우 원래 문자열을 반환한다.
 */

export const extractMenuName = (values: string[]): string[] => {
  return values.map((v) => {
    const first = v.indexOf("(");
    const last = v.lastIndexOf(")");
    if (first !== -1 && last !== -1 && last > first) {
      return v.substring(first + 1, last); // 괄호 안 텍스트만
    }
    return v;
  });
};

export const extractMenuCodeOnly = (values: string[]): string[] => {
  return values.map((v) => v.split("(")[0].trim());
};

export const extractMenuCodeAndLabel = (
  values: string[],
): { links: string[]; labels: Record<string, string> } => {
  return {
    links: values.map((v) => v.split("(")[0].trim()),
    labels: values.reduce(
      (acc, v) => {
        const code = v.split("(")[0].trim();
        const match = v.match(/\((.*)\)/);
        acc[code] = match ? match[1] : "";
        return acc;
      },
      {} as Record<string, string>,
    ),
  };
};
